import axios, { AxiosInstance } from 'axios'
import { API_HOST } from '@/shared/constants/const'
import { COMMON_HEADERS } from '@/shared/constants/http'
import { convertLocalhostTo127 } from '@/shared/hooks/useLocalhostRedirect'

// CSRF 二重送信トークン.
// 同一オリジン(unified)は CSRF cookie が __Host-csrftoken かつ HttpOnly=false のため JS から読める.
// 旧 standard/mtls 構成は csrftoken を持ち従来どおり Referer 方式で通す(=トークンを送らない)ため,
// unified 固有の __Host-csrftoken が「読めたときだけ」X-CSRFToken を送る. 旧構成には
// __Host-csrftoken が存在しないので送信されず, 既存の Referer フォールバックは一切変わらない.
const UNIFIED_CSRF_COOKIE_NAME = '__Host-csrftoken'
const CSRF_UNSAFE_METHODS = ['post', 'put', 'patch', 'delete']

const getUnifiedCsrfToken = (): string | null => {
  const match = document.cookie.match(
    new RegExp('(?:^|;\\s*)' + UNIFIED_CSRF_COOKIE_NAME + '=([^;]+)')
  )
  return match ? decodeURIComponent(match[1]) : null
}

const client: AxiosInstance = axios.create({
  baseURL: `${API_HOST}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// リクエストインターセプター
client.interceptors.request.use(
  (config) => {
    // localhost URLを127.0.0.1に変換（開発環境でのCSRF対応）
    if (config.baseURL) {
      config.baseURL = convertLocalhostTo127(config.baseURL)
    }
    if (config.url) {
      config.url = convertLocalhostTo127(config.url)
    }

    // unified(同一オリジン)では __Host-csrftoken を X-CSRFToken に載せて二重送信する.
    // cookie が読めない旧構成では何もしない(Referer 方式のまま).
    const method = config.method?.toLowerCase()
    if (method && CSRF_UNSAFE_METHODS.includes(method)) {
      const csrfToken = getUnifiedCsrfToken()
      if (csrfToken) {
        config.headers = config.headers ?? {}
        config.headers[COMMON_HEADERS.X_CSRF_TOKEN] = csrfToken
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// レスポンスインターセプター
client.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default client
